// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summaryBlock__lksVr {
  display: flex;
  padding: 0px 25px;
  justify-content: space-between;
  height: 45px;
}

.summaryBlockTotal__vPdJ2 {
  display: flex;
  width: 25%;
  align-items: center;
}

.summaryBlockTotalName__bGGF2 {
  margin-right: 10px;
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.summaryBlockBox__AyQMA {
  display: flex;
  width: 80%;
  gap: 50px;
  justify-content: flex-end;
}

.summaryBlockItem__ugzpg {
  width: 25%;
  display: flex;
  align-items: center;
  padding-right: 50px;
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  gap: 10px;
}

.summaryBlockCount__bzBvs {
  color: var(--legend-for-header-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 12px;
  text-transform: uppercase;
}

.progressCritical__LL0IV {
  height: 8px;
  display: block;
  background: var(--legend-for-header-critical);
}

.progressHigh__cjt7w {
  height: 8px;
  display: block;
  background: var(--legend-for-header-high);
}

.progressStandard___4zCU {
  height: 8px;
  display: block;
  background: var(--legend-for-header-standard);
}

.summaryBlockItemTooltip__WgrFq {
  max-width: 400px;
  padding: 8px !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 4px !important;
  text-align: left !important;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItems/components/ActionItemsSummary/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,UAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,UAAA;EACA,SAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,cAAA;EACA,6CAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,cAAA;EACA,yCAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,cAAA;EACA,6CAAA;AAzEF;;AA4EA;EACE,gBAAA;EAxFA,uBAAA;EACA,qBAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;AAgBF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.summaryBlock {\n  display: flex;\n  padding: 0px 25px;\n  justify-content: space-between;\n  height: 45px;\n}\n\n.summaryBlockTotal {\n  display: flex;\n  width: 25%;\n  align-items: center;\n}\n\n.summaryBlockTotalName {\n  margin-right: 10px;\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.summaryBlockBox {\n  display: flex;\n  width: 80%;\n  gap: 50px;\n  justify-content: flex-end;\n}\n\n.summaryBlockItem {\n  width: 25%;\n  display: flex;\n  align-items: center;\n  padding-right: 50px;\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  gap: 10px;\n}\n\n.summaryBlockCount {\n  color: var(--legend-for-header-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 12px;\n  text-transform: uppercase;\n}\n\n.progressCritical {\n  height: 8px;\n  display: block;\n  background: var(--legend-for-header-critical);\n}\n\n.progressHigh {\n  height: 8px;\n  display: block;\n  background: var(--legend-for-header-high);\n}\n\n.progressStandard {\n  height: 8px;\n  display: block;\n  background: var(--legend-for-header-standard);\n}\n\n.summaryBlockItemTooltip {\n  max-width: 400px;\n  @include tooltip;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summaryBlock": `summaryBlock__lksVr`,
	"summaryBlockTotal": `summaryBlockTotal__vPdJ2`,
	"summaryBlockTotalName": `summaryBlockTotalName__bGGF2`,
	"summaryBlockBox": `summaryBlockBox__AyQMA`,
	"summaryBlockItem": `summaryBlockItem__ugzpg`,
	"summaryBlockCount": `summaryBlockCount__bzBvs`,
	"progressCritical": `progressCritical__LL0IV`,
	"progressHigh": `progressHigh__cjt7w`,
	"progressStandard": `progressStandard___4zCU`,
	"summaryBlockItemTooltip": `summaryBlockItemTooltip__WgrFq`
};
module.exports = ___CSS_LOADER_EXPORT___;
